export const portfolios = {
  Web: [
    {
      type: "featured",
      name: "Reddish",
      image: require("./image/reddish.png"),
      description:
        "Reddit clone (a social media site) made with MERN stack & Redux.",
      demo: "https://reddish-cd0l.onrender.com/",
      source: "https://github.com/manish6263/Reddish",
      tools: ["React", "HTML", "CSS", "Node JS", "MongoDB", "cloudinary"],
    },
    {
      type: "featured",
      name: "PatelWeather",
      image: require("./image/weather.png"),
      description:
        "A simple weather app that allows you to get current weather information, based on the city you enter. I also added the login signup functionality for future scope. In this application you can also see the latest news.",
      demo: "https://weather-app-y7ua.onrender.com/",
      source: "https://github.com/manish6263/Weather-App",
      tools: ["React", "HTML", "CSS", "Weather API"],
    },
    {
      type: "featured",
      name: "NoteZipper",
      image: require("./image/note-zipper.png"),
      description:
        "NoteZipper is the application that I developed for letting users create notes and store them online in the most hassle-free way possible. The UI is as simple as it can get and the app comes with an organised approach to managing all the notes publicly at one place with advanced search filters.",
      demo: "https://note-zipper-nybz.onrender.com/",
      source: "https://github.com/manish6263/Note-Zipper",
      tools: ["React", 'CSS', "Node JS", "MongoDB"],
    },
    {
      type: "featured",
      name: "picApic",
      image: require("./image/picApic.png"),
      description:
        "picApic is a platform where people can share their pictures, can see, like and comment other users pictures",
      demo: "https://pickapic.onrender.com/",
      source: "https://github.com/manish6263/pickApic",
      tools: ["React", "CSS", "MongoDB", 'Node JS', 'Cloudinary'],
    },
    {
      type: "featured",
      name: "Github Finder",
      image: require("./image/github-finder.png"),
      description:
        "Github Finder is a platform where people can search github users and can see their public repositories.",
      demo: "https://git-hub-finder-six.vercel.app/",
      source: "https://github.com/manish6263/GitHub-Finder",
      tools: ["React", "CSS", "Github API"],
    },
    {
      type: "featured",
      name: "EG shop grocery",
      image: require("./image/grocery.png"),
      description:
        "EG shop is a fast-growing online grocery shopping application in India.Unlike other online grocery apps, EG shop receives the order from customers and deliver the product within 3 hours to doorsteps.",
      demo: "https://ecommerce-asdw.onrender.com/",
      source: "https://github.com/manish6263/ECommerce",
      tools: ["React", "CSS", "NodeJS", 'MongoDB', 'Cloudinary'],
    }
  ],
};